import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["max"];
import React, { useEffect, useState, useCallback } from 'react';
import { instanceOf, string } from 'prop-types';
import parse from 'date-fns/parse';
import format from 'date-fns/format';
import isValid from 'date-fns/isValid';
import isBefore from 'date-fns/isBefore';
import MaskedInput from '../masked-input/MaskedInput';
import CustomDateMask from './CustomDateMask';
import CustomRangeMask from './CustomRangeMask';
const DATE_FORMAT = 'MM/dd/yyyy';
const createMaskOptions = function ({
  max,
  lazy = false
} = {}) {
  return {
    mask: CustomDateMask,
    lazy,
    pattern: 'm/`d/`Y',
    blocks: {
      m: {
        mask: CustomRangeMask,
        from: 1,
        to: 12,
        maxLength: 2,
        placeholderChar: '_'
      },
      d: {
        mask: CustomRangeMask,
        from: 1,
        to: 31,
        maxLength: 2,
        placeholderChar: '_'
      },
      Y: {
        mask: CustomRangeMask,
        from: 1900,
        to: max ? max.getFullYear() : 2099,
        placeholderChar: '_'
      }
    },
    format(date) {
      return format(date, DATE_FORMAT);
    },
    parse(str) {
      return parse(str, DATE_FORMAT, new Date());
    },
    validate(value) {
      // february never has 30+ days
      if (/02\/3/.test(value)) {
        return false;
      }

      // validate full date
      if (value.length === 10 && !/[MDY]/.test(value)) {
        const parsedDate = parse(value, DATE_FORMAT, new Date());
        return isValid(parsedDate) && (!max || max && isBefore(parsedDate, max));
      }

      // return true so use is able to enter the rest of the date
      return true;
    }
  };
};
export const defaultMaskOptions = createMaskOptions();
function DateInput(props) {
  const {
      max
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const [maskOptions, setMaskOptions] = useState(function () {
    return createMaskOptions({
      max,
      lazy: true
    });
  });
  const getRawValue = useCallback(function (mask) {
    const [month, day, year] = mask.value.split('/');
    setMaskOptions(createMaskOptions({
      mask,
      lazy: !mask.unmaskedValue
    }));
    return {
      month,
      day,
      year
    };
  }, []);
  useEffect(function () {
    setMaskOptions(createMaskOptions({
      max
    }));
  }, [max]);
  return /*#__PURE__*/React.createElement(MaskedInput, Object.assign({}, otherProps, {
    inputMode: "decimal",
    maskOptions: maskOptions,
    getRawValue: getRawValue
  }));
}
DateInput.defaultProps = {
  placeholder: 'MM/DD/YYYY'
};
DateInput.propTypes = {
  /**
   * The maximum date a user should be able to type into the Input.
   */
  max: instanceOf(Date),
  /**
   * @ignore
   */
  placeholder: string
};
export default DateInput;